import { useMemo } from 'react';
import PropTypes from 'prop-types';
import Skeleton from 'wsm-skeleton';

import RatingRow from '../RatingRow';
import { randomWidthSkeleton } from '../../utilities/modalUtils';

import './Skeleton.scss';

const ReviewSkeleton = ({ isMobile = false, isLastReview = false }) => {
	const textHeight = isMobile ? '18px' : '20px';
	const circleScoreDimension = isMobile ? '57px' : '66px';

	// Memoized random value, calculated once on mount
	const randomValue = useMemo(() => ({
		reviewName: randomWidthSkeleton('pixel'),
		reviewLine1: randomWidthSkeleton('percentage'),
		reviewLine2: randomWidthSkeleton('percentage'),
		reviewLine3: randomWidthSkeleton('percentage'),
		showMoreReview: Math.random() < 0.5
	}), []);

	return (
		<div className={`d-flex flex-column ${!isLastReview ? 'border-bottom pb-4 mb-4' : ''}`} aria-hidden="true">
			{/* Review item header */}
			<div className="kbb-review-item d-flex align-items-center mb-21 pl-1">
				<Skeleton width={circleScoreDimension} skeletonClasses="mr-4" circle />

				<div className='d-flex flex-column gap-1'>
					<Skeleton width={randomValue.reviewName} height={textHeight} />
					<Skeleton width="200px" height={isMobile ? '14px' : '16px'} />
				</div>
			</div>

			{/* Review text: Pros + Cons */}
			{randomValue.showMoreReview && (
				<>
					<div className='mb-21 d-flex flex-column gap-1 mb-3 pb-3 mr-lg-390'>
						<Skeleton width="100%" height={textHeight} />
						<Skeleton width="100%" height={textHeight} />
						<Skeleton width={randomValue.reviewLine1} height={textHeight} />
					</div>

					<div className='mb-21 d-flex flex-column gap-1 mb-3 pb-3 mr-lg-390'>
						<Skeleton width="100%" height={textHeight} />
						<Skeleton width={randomValue.reviewLine2} height={textHeight} />
					</div>
				</>)}

			{/* Review text: Content */}
			<div className="mb-21 d-flex flex-column gap-1">
				<Skeleton width="100%" height={textHeight} />
				<Skeleton width="100%" height={textHeight} />
				{randomValue.showMoreReview && <Skeleton width="100%" height={textHeight} />}
				<Skeleton width={randomValue.reviewLine3} height={textHeight} />
			</div>


			{/* Review ratings */}
			<div className="kbb-review-ratings mb-21">
				<div className="row">
					<div className="col-12 col-md-6">
						<RatingRow label="Value" isSkeleton textHeightSkeleton={textHeight} />
						<RatingRow label="Quality" isSkeleton textHeightSkeleton={textHeight} />
						<RatingRow label="Reliability" isSkeleton textHeightSkeleton={textHeight} />
					</div>
					<div className="col-12 col-md-6">
						<RatingRow label="Performance" isSkeleton textHeightSkeleton={textHeight} />
						<RatingRow label="Comfort" isSkeleton textHeightSkeleton={textHeight} />
						<RatingRow label="Styling" isSkeleton textHeightSkeleton={textHeight} />
					</div>
				</div>
			</div>
			
			{/* Recommend this vehicle */}
			<div className="d-flex align-items-center">
				<Skeleton width={isMobile ? '155px' : '180px'} height={textHeight} />
			</div>
		</div>

	);
};


export default ReviewSkeleton;

ReviewSkeleton.propTypes = {
    isMobile: PropTypes.bool,
    isLastReview: PropTypes.bool
};


